module.exports = __webpack_public_path__ + "static/scale-model-of-lakewood-colorado-decf6e42e60eac08a4837cdd2a8ab568.png";